import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {

  private permissionsSubject = new BehaviorSubject<string[]>([]);
  permissionsChanged$ = this.permissionsSubject.asObservable();

  constructor(private auth: AuthService) {
    this.ensureFresh();
  }

  ensureFresh(): void {
    const token = this.auth.getAccessToken() || '';
    const perms = this.extractPermissions(token);
    const current = this.permissionsSubject.getValue();
    if (!this.arraysEqual(perms, current)) {
      this.permissionsSubject.next(perms);
    }
  }

  refreshFromToken(token: string | null | undefined): void {
    const perms = this.extractPermissions(token || '');
    this.permissionsSubject.next(perms);
  }

  getPermissions(): string[] { return this.permissionsSubject.getValue(); }
  has(p: string): boolean { return this.getPermissions().includes(p); }
  hasAny(list: string[]): boolean { return list.some(x => this.has(x)); }
  isAdmin(): boolean { return this.has('admin'); }
  isEnt(): boolean { return this.has('ntrip-ent'); }
  isAdminOrEnt(): boolean { return this.isAdmin() || this.isEnt(); }

  private extractPermissions(token: string): string[] {
    try {
      if (!token) return [];
      const parts = token.split('.');
      if (parts.length !== 3) return [];
      const payload = parts[1];
      const json = this.base64UrlDecode(payload);
      const obj = JSON.parse(json) || {};
      const perms: any = obj['permissions'];
      if (Array.isArray(perms)) {
        return perms.filter((x: any) => typeof x === 'string');
      }
      return [];
    } catch {
      return [];
    }
  }

  private base64UrlDecode(str: string): string {
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    const binary = atob(base64);
    const out = decodeURIComponent(Array.from(binary).map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
    return out;
  }

  private arraysEqual(a: string[], b: string[]): boolean {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }
}




